class BannerTicker extends HTMLElement {
  connectedCallback() {
    this.interval = Number(this.dataset.interval) || 3000;
    this.staggerStep = Number(this.dataset.stagger) || 500;
    this.transitionMs = Number(this.dataset.transition) || 600;
    this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.state = new Map();
    this.isPlaying = false;

    this.tickers = [...this.querySelectorAll('[data-ticker]')];
    this.initTickers();

    this.handleIntersect = this.handleIntersect.bind(this);
    this.observer = new IntersectionObserver(this.handleIntersect, { threshold: 0.1 });
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.pause();
    this.observer?.disconnect();
  }

  initTickers() {
    for (const ticker of this.tickers) {
      const options = [...ticker.querySelectorAll('[data-option]')];
      options.forEach((option, index) => option.classList.toggle('is-active', index === 0));

      this.state.set(ticker, {
        options,
        index: 0,
        rotate: ticker.dataset.rotate !== 'false',
        starter: null,
        timer: null,
      });
    }
  }

  handleIntersect(entries) {
    const [entry] = entries;
    if (entry.isIntersecting) {
      this.play();
    } else {
      this.pause();
    }
  }

  play() {
    if (this.isPlaying || this.reduceMotion) return;
    this.isPlaying = true;

    this.tickers.forEach((ticker, index) => {
      const state = this.state.get(ticker);
      if (!state.rotate || state.options.length < 2) return;

      state.starter = window.setTimeout(() => {
        this.advance(ticker);
        state.timer = window.setInterval(() => this.advance(ticker), this.interval);
      }, index * this.staggerStep);
    });
  }

  pause() {
    this.isPlaying = false;
    for (const state of this.state.values()) {
      window.clearTimeout(state.starter);
      window.clearInterval(state.timer);
      state.starter = null;
      state.timer = null;
    }
  }

  advance(ticker) {
    const state = this.state.get(ticker);
    const { options } = state;
    if (options.length < 2) return;

    const previous = state.index;
    const next = (previous + 1) % options.length;
    const leaving = options[previous];

    leaving.classList.remove('is-active');
    leaving.classList.add('is-leaving');
    options[next].classList.add('is-active');

    window.setTimeout(() => leaving.classList.remove('is-leaving'), this.transitionMs);
    state.index = next;
  }
}

if (!customElements.get('banner-ticker')) {
  customElements.define('banner-ticker', BannerTicker);
}
